import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { s3Url } from "../utils/s3_url";
import { upload } from "../actions/upload";
import Dropzone from "react-dropzone";
import { Icon, Loader, Segment } from "semantic-ui-react";
import "./FileUploader.scss";
import classNames from "classnames";
import { coreUpload, FileUsage } from "../actions/coreUpload";

interface FileUploaderProps {
  file: any;
  setFile: any;
  uploadId: string;
  style?: any;
  accept?: string;
  placeholder: any;
  baseUrl: string;
  folder?: string;
  bucket?: string;
  multiple?: boolean;
  usage?: FileUsage;
  useCore?: boolean;
}

export default ({
  baseUrl,
  placeholder,
  accept,
  file,
  folder,
  bucket,
  setFile,
  uploadId,
  multiple = false,
  usage,
  useCore,
}: FileUploaderProps) => {
  const dispatch = useDispatch();
  const params = useParams<{ site: string }>();
  const [isLoading, setIsLoading] = useState(false);

  const onDrop = useCallback(
    async (acceptedFiles: any) => {
      setIsLoading(true);
      for (const file of acceptedFiles) {
        if (useCore && !usage) throw new Error("usage is required when using coreUpload");
        const uploadOptions = {
          id: uploadId,
          site: params.site,
          file,
          folder,
          bucket,
          usage,
        };
        const response = (await dispatch(useCore ? coreUpload(uploadOptions) : upload(uploadOptions))) as any;
        const fileState = {
          id: uploadId,
          name: file.name,
          url: useCore ? response.payload.url : s3Url(response.payload, baseUrl),
          percentUploaded: 100,
          payload: response.payload,
          key: response.payload.children?.find((child: any) => child.name == "Key").value,
          type: file.type,
          size: file.size,
        } as any;
        setFile(fileState);
      }
      setIsLoading(false);
    },
    [setFile, dispatch, uploadId],
  );
  const renderPreview = () => {
    return <img alt={file.name} key={file.key} src={file.url} style={{ maxHeight: "100px", maxWidth: "100px" }} />;
  };
  return (
    <div className='FileUploader' id={uploadId}>
      {isLoading && (
        <Segment className='tw-mb-0 tw-h-[39px] tw-rounded-none tw-border-dashed tw-bg-[#FAFBFC]'>
          <Loader active size='small' />
        </Segment>
      )}

      {/* TODO: Swap out the Dropzone component for a more accessible one. Currently the dropzone has a separate focus state from the attachment button. */}
      <div className={classNames({ "tw-sr-only": isLoading })}>
        <Dropzone onDrop={onDrop} accept={accept} multiple={multiple}>
          {({ getRootProps, getInputProps, isDragActive }) => {
            const showPreview = file?.url && !isDragActive;
            const dropzoneClassName = ["dropzone", isDragActive ? "active" : "", showPreview ? "preview" : ""].join(
              " ",
            );
            return (
              <div {...getRootProps({ className: dropzoneClassName })}>
                <input {...getInputProps()} />
                {!isDragActive ? (
                  showPreview ? (
                    renderPreview()
                  ) : (
                    placeholder
                  )
                ) : (
                  <div className='active-drag-area'>
                    <Icon name='cloud upload' size='large' color='grey' />
                    <span>Drop the File Here</span>
                  </div>
                )}
              </div>
            );
          }}
        </Dropzone>
      </div>
    </div>
  );
};
